module.exports = __webpack_public_path__ + "img/premium.4b40af12.png";